import "./cmdHandler.css";

import Hammer from "../../../module/hammer";
import { onTouch } from "../../../hammerUtil";

/**
 * command Handler
 */
class cmdHandler {
  /**
   * @param {object} body
   * @param {Canvas} canvas
   */
  constructor(body, canvas) {
    this.body = body;
    this.canvas = canvas;

    this.iconsCreated = false;
    this.cmdHammers = [];
    this.boundFunctions = {};
    this.touchTime = 0;
    this.activated = false;
    this.options = {};
  }

  /**
   *
   * @param {object} options
   */
  setOptions(options) {
    if (options !== undefined) {
      this.options = options;
      this.create();
    }
  }

  /**
   * Creates or refreshes commander and sets key bindings
   */
  create() {
    if (this.options.commandButtons === true) {
      if (this.iconsCreated === false) {
        this.loadCommandElements();
      }
    } else if (this.iconsCreated === true) {
      this.cleanCommand();
    }
  }

  /**
   * Cleans up previous command items
   */
  cleanCommand() {
    // clean hammer bindings
    if (this.cmdHammers.length != 0) {
      for (let i = 0; i < this.cmdHammers.length; i++) {
        this.cmdHammers[i].destroy();
      }
      this.cmdHammers = [];
    }

    // clean up previous command items
    if (
      this.commandDOM &&
      this.commandDOM["wrapper"] &&
      this.commandDOM["wrapper"].parentNode
    ) {
      this.commandDOM["wrapper"].parentNode.removeChild(
        this.commandDOM["wrapper"]
      );
    }

    this.iconsCreated = false;
  }

  /**
   * Creation of the command controls nodes. They are drawn over the rest of the nodes and are not affected by scale and translation
   * they have a triggerFunction which is called on click. If the position of the command controls is dependent
   * on this.frame.canvas.clientWidth or this.frame.canvas.clientHeight, we flag horizontalAlignLeft and verticalAlignTop false.
   * This means that the location will be corrected by the _relocateCommand function on a size change of the canvas.
   *
   * @private
   */
  loadCommandElements() {
    this.cleanCommand();

    this.commandDOM = {};
    const commandDivs = [
      //"info",
      "execute",
      "save",
      "arrange",
      "erase",
      "gear",
      "link",
      "copy",
      "trash",
    ];
    const commandDivActions = [
      //"_info",
      "_execute",
      "_save",
      "_arrange",
      "_erase",
      "_config",
      "_link",
      "_copy",
      "_remove",
    ];
    const commandDivTitle = [
      //"Information",
      "Execute",
      "Save",
      "Arrange",
      "Erase",
      "Config",
      "Link",
      "Copy",
      "Remove",
    ];

    this.commandDOM["wrapper"] = document.createElement("div");
    this.commandDOM["wrapper"].className = "vis-command";
    this.canvas.frame.appendChild(this.commandDOM["wrapper"]);

    this.commandDOM["command"] = document.createElement("div");
    this.commandDOM["command"].className = "vis-pane";
    this.commandDOM["wrapper"].appendChild(this.commandDOM["command"]);

    this.commandDOM["separate"] = document.createElement("div");
    this.commandDOM["separate"].className = "vis-actbutton vis-separate";
    this.commandDOM["wrapper"].appendChild(this.commandDOM["separate"]);

    for (let i = 0; i < commandDivs.length; i++) {
      this.commandDOM[commandDivs[i]] = document.createElement("div");
      this.commandDOM[commandDivs[i]].className =
        "vis-actbutton vis-" + commandDivs[i];
      this.commandDOM[commandDivs[i]].title = commandDivTitle[i];
      this.commandDOM["wrapper"].appendChild(this.commandDOM[commandDivs[i]]);

      const hammer = new Hammer(this.commandDOM[commandDivs[i]]);
      onTouch(hammer, this[commandDivActions[i]].bind(this));
      this.cmdHammers.push(hammer);
    }

    this.iconsCreated = true;
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _info() {
    this.body.emitter.emit("command", { action: "info" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _execute() {
    this.body.emitter.emit("command", { action: "execute" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _save() {
    this.body.emitter.emit("command", { action: "save" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _erase() {
    this.body.emitter.emit("command", { action: "erase" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _arrange() {
    this.body.emitter.emit("command", { action: "arrange" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _config() {
    this.body.emitter.emit("command", { action: "setting" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _link() {
    this.body.emitter.emit("command", { action: "link" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _copy() {
    this.body.emitter.emit("command", { action: "copy" });
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _remove() {
    this.body.emitter.emit("command", { action: "remove" });
  }
}

export default cmdHandler;
